<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date"><span class="">转化开始时间<i class="icon_select"></i></span> </label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.beginDate" type="date" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd ">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box" style="width: 180px;">
					<label for="start-date">至：</label>
					<span class="order-query-form-input">
						<el-date-picker v-model="orderForm.endDate" type="date" placeholder="选择日期时间"
							class="setTimePicker" value-format="yyyy-MM-dd ">
						</el-date-picker>
					</span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">推荐人手机：</label>
					<span class="order-query-form-input"><input type="number" v-model="orderForm.salemanPhone"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">推荐人姓名：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.salemanName"></span>
				</div>
				<div class="order-query-form-box">
					<label for="start-date">货主手机：</label>
					<span class="order-query-form-input"><input type="number" v-model="orderForm.ownerPhone"></span>
				</div>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>
		<div class="data-table-box">
			<common-table ref="CommonTableRef" :tableColumns="tableColumns" :data="dataList" :loading="loading"
				:showPage="togglePage" :pageConfig="pageConfig" :bottomHandleArr="bottomHandleArr"
				@selectionChange="selectionChange" @currentChange="currentChange" @sizeChange="sizeChange">
			</common-table>
		</div>
		<div class="previewImg" v-if="toggleImg">
			<img @click="toggleImg=false" class="closeImg" src="../../assets/images/close.png" alt="">
			<div class="previewImgWarp">
				<div class="mypreviewImg">
					<img :src="previewPath">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'
	export default {
		name: 'Recommend',
		props: [],
		data() {
			return {
				tableColumns: [{
						key: 'waybillCompleteDate',
						title: '转化时间'
					},
					{
						key: 'salemanName',
						title: '推荐人名字'
					},
					{
						key: 'salemanPhone',
						title: '推荐人手机号'
					},
					{
						key: 'ownerName',
						title: '货主名字'
					},
					{
						key: 'ownerPhone',
						title: '货主手机号'
					},
					// {key: 'numAddress',title: '被推荐人归属地'},
					// {key: 'userTypeDesc',title: '用户类型'},

				],
				pageConfig: {
					total: 0,
					pageSize:50,
					currentPage: 1,
				},
				bottomHandleArr: [
					// {
					//     label: '审核',
					//     handler: () => this.setAudit()
					// },
					{
						label: '导出',
						handler: () => this.exportTable()
					},
				],
				loading: false,
				showPage: false,
				toggleImg: false,
				previewPath: null,
				dataList: [], //订单列表
				orderForm: {
					beginDate: null, //	推荐开始始时间	string	格式：yyyy-MM-dd HH:mm:ss
					endDate: null, //  结束时间	string	格式：yyyy-MM-dd HH:mm:ss
					current: 0,
					salemanPhone: '',
					ownerPhone: '',
					salemanName: '',
				},
				togglePage: false, //是否显示分页


			}
		},
		created() {},
		methods: {
			sizeChange(size) {
				this.pageConfig.currentPage = 1
				this.pageConfig.pageSize = size
				this.searchList()
			},
			currentChange(currentPage) {
				this.pageConfig.currentPage = currentPage
				this.searchList()
			},

			exportTable() {
				let that = this;
				if (this.dataList.length < 1) {
					that.$toast.stMessage('暂无数据', true)
					return;
				}
				let pages = {};
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				const sendData = {
					...this.orderForm,
					exportColumnFiledNames: this.tableColumns.map((item) => {
						return item.key
					}).filter(item => {
						return item && item.trim()
					})
				}
				sendData.beginDate = sendData.beginDate ? new Date(sendData.beginDate).getTime() : ''
				sendData.endDate = sendData.endDate ? new Date(sendData.endDate).getTime() : ''
				Object.assign(sendData, pages)
				this.$server.common.exportTable('/appuser/recommendExport', sendData, (res) => {
					console.log('导出成功')
				})
			},
			argImg(src) {
				this.previewPath = src;
				this.toggleImg = true;
			},
			searchList(flag) {
				let that = this;
				let pages = {};
				let orderForm = this.orderForm;
				pages.size = this.pageConfig.pageSize;
				pages.current = this.pageConfig.currentPage;
				if(flag) pages.current = 1;
			
				this.loading = true;
				Object.assign( this.orderForm, pages)
			this.getData(this.orderForm)
			},
			getData(data) {
				let that = this;
				this.$server.material.ownerconversion(data, (res) => {
					console.log(res)
					this.loading = false;
					if (res.code == 0) {
						for (var i = 0; i < res.data.records.length; i++) {
							res.data.records[i].waybillCompleteDate = that.timestampToTime(res.data.records[i]
								.waybillCompleteDate)
							this.dataList = res.data.records;
						}
						this.pageConfig.total = res.data.total;
						this.pageConfig.currentPage = res.data.current;
						if (res.data.total > 0) {
							this.togglePage = true;
						}
					}
				})
			},
			//格式化时间戳
			timestampToTime(Time) {
				var date = new Date(Time) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = date.getDate() + ' ';
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				return Y + M + D;

			},
			selectionChange(row) {
				this.selectedList = row;
			},
			cellClass(row) {
				if (row.columnIndex === 0) {
					return 'disabledCheck'
				}
			},
		},
		mounted() {

		}
	}
</script>
<style scoped>
	.st-main-content {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.data-table-box {
		height: auto;
		background: #FFF;
		padding: 8px;
		box-sizing: border-box;
	}

	.data-table {
		margin-bottom: 8px;
	}

	.query-setting-box-left {
		flex-grow: 0;
	}

	.previewImg {
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background-color: rgba(0, 0, 0, .5);
		z-index: 99;
	}

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	.previewImgWarp {
		position: absolute;
		left: 50%;
		top: 50%;
		margin-left: -300px;
		margin-top: -300px;
		width: 600px;
		height: 600px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.mypreviewImg {
		display: inline-block;
		border: 5px solid #fff;
		border-radius: 3px;
		overflow: hidden;
	}

	.mypreviewImg img {
		max-width: 600px;
	}

	.closeImg {
		position: absolute;
		top: 20px;
		right: 20px;
		cursor: pointer;
	}
</style>
